<template>
    <div class="text-center">
        <v-bottom-sheet
            :value="value"
            @input="update"
            inset
            :persistent="loading"
        >
        <v-sheet
            class="text-center"
            style="height: 100%;"
        >
                <v-btn
                    class="mt-6"
                    text
                    color="primary"
                    @click="$emit('close', true)"
                >
                    Cancelar
                </v-btn>
                <div class="py-3 d-flex flex-column px-3" style="height: 100%;">
                    <span class="title mb-2">Confirme o CVV do cartão</span>
                    <span>Preencha o cvv do cartão selectionado para finalizar pedido</span>
                    <v-text-field
                        color="primary"
                        name="cvv"
                        class="mt-4"
                        :value="cvv"
                        @input="$emit('cvv', $event)"
                        label="CVV"
                        dense
                        single-line
                        rounded
                        outlined
                    />
                    <!-- :error="!!errors?.email" -->
                        <!-- :error-messages="errors?.email && errors?.email[0]" -->
                    <v-btn class="mt-3" color="primary" @click="submit">
                        <span>
                            FINALIZAR COMPRA
                        </span>
                    </v-btn>
                </div>
            </v-sheet>
        </v-bottom-sheet>
    </div>
</template>

<script>

export default {
    name: "cardCvvSheet",
    props: ['value', 'loading', 'cvv'],
    data() {
        return {
        }
    },
    methods: {
      update(newValue) { this.$emit('input', newValue); },
      submit() {
          this.$emit('close', true);
          this.$emit('submit', true);
      }
    }
}
</script>